
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("dhbEh", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $6b4nE = parcelRequire("6b4nE");


var $9DHhW = parcelRequire("9DHhW");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $7Ndnw = parcelRequire("7Ndnw");


var $7QUD1 = parcelRequire("7QUD1");


var $hIaUw = parcelRequire("hIaUw");


var $8a9Dm = parcelRequire("8a9Dm");


var $dizL5 = parcelRequire("dizL5");


var $bQm3c = parcelRequire("bQm3c");


var $ep3mz = parcelRequire("ep3mz");


var $6UqI3 = parcelRequire("6UqI3");


var $6uUjl = parcelRequire("6uUjl");


var $3IBnw = parcelRequire("3IBnw");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3jwuS = parcelRequire("3jwuS");


var $c54hr = parcelRequire("c54hr");














var $lfoFx = parcelRequire("lfoFx");


var $9fBoq = parcelRequire("9fBoq");


var $al4VD = parcelRequire("al4VD");

const $ced39bfea5ef5993$var$Container = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isLoading: isLoading, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_kqswh2mm",
            __cmplp.isLoading ? "_syaz1rpy" : "_syazn7od",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $ced39bfea5ef5993$var$CenterSpinner = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_18u0x0bf _19pkx0bf _1e0c1txw _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
function $ced39bfea5ef5993$export$9f275aff884e1431(t0) {
    const $ = (0, $bDgLe.c)(16);
    const { extension: extension, onClick: onClick, isLoading: isLoading } = t0;
    let t1;
    if ($[0] !== extension || $[1] !== onClick) {
        t1 = (e)=>{
            e.stopPropagation();
            onClick(extension);
        };
        $[0] = extension;
        $[1] = onClick;
        $[2] = t1;
    } else t1 = $[2];
    const onClickCB = t1;
    const t2 = extension.id;
    let t3;
    if ($[3] !== extension) {
        t3 = (0, $9fBoq.extensionTitle)(extension);
        $[3] = extension;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== isLoading) {
        t4 = isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ced39bfea5ef5993$var$CenterSpinner, {
            "data-test-id": "forge-ui-extension-loading-spinner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
            size: "small",
            interactionName: "forge-content-tools-loading"
        }));
        $[5] = isLoading;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== isLoading || $[8] !== t3 || $[9] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ced39bfea5ef5993$var$Container, {
            isLoading: isLoading
        }, t3, t4);
        $[7] = isLoading;
        $[8] = t3;
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== extension.id || $[12] !== isLoading || $[13] !== onClickCB || $[14] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $al4VD.ContentToolsItem), {
            id: t2,
            isDisabled: isLoading,
            label: t5,
            onClick: onClickCB
        });
        $[11] = extension.id;
        $[12] = isLoading;
        $[13] = onClickCB;
        $[14] = t5;
        $[15] = t6;
    } else t6 = $[15];
    return t6;
}
$ced39bfea5ef5993$export$9f275aff884e1431.propTypes = {
    extension: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).object.isRequired,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).func.isRequired,
    isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool.isRequired
};



var $9MrOn = parcelRequire("9MrOn");

const $0c33e41081c1500e$var$EXPERIENCE_NAME = (0, $irVI7.VIEW_PAGE_CONTENT_TOOLS_FORGE_EXPERIENCE);
function $0c33e41081c1500e$export$7cf22b806dbb23cb({ contentId: contentId, spaceKey: spaceKey, children: children, onLoadComplete: onLoadComplete, isDropdownMenuOpen: isDropdownMenuOpen, lazyLoaderPlaceholderComponent: lazyLoaderPlaceholderComponent = null }) {
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext)); // Forge menu items are behaving a little different than other menu items. They show a loading spinner if one of them
    // is clicked. There are a few different cases that needs to be handled while a forge extension is being loaded:
    // 1. Show a loading spinner while an extension id being loaded.
    //    - Stop showing the loading spinner once the extension is loaded.
    //    - Close the dropdown menu once the extension is loaded.
    // 2. If dropdown menu is closed while an extension is being loaded then stop loading the extension.
    // If there's a selected extension then `loadExtension` state changes like this:
    // +----------+----------------------+------------------+
    // |isLoading |   isDropdownMenuOpen |    loadExtension |
    // +----------------------------------------------------+
    // |          |                      |                  |
    // | false    |   false              |    true          |  --> keep showing the loaded extension
    // |          |                      |                  |
    // | false    |   true               |    true          |  --> keep showing the loaded extension
    // |          |                      |                  |
    // | true     |   false              |    false         |  --> stop loading the extension
    // |          |                      |                  |
    // | true     |   true               |    true          |  --> keep loading the extension
    // +----------+----------------------+------------------+
    const [extension, showExtension] = (0, $cozmU.useState)(null);
    const [isLoading, setLoading] = (0, $cozmU.useState)(false);
    const loadExtension = extension && !(isLoading && !isDropdownMenuOpen);
    (0, $cozmU.useEffect)(()=>{
        if (!loadExtension) {
            experienceTracker.abort({
                name: $0c33e41081c1500e$var$EXPERIENCE_NAME,
                reason: 'Canceled by user'
            });
            setLoading(false);
            showExtension(null);
        }
    }, [
        loadExtension,
        experienceTracker
    ]);
    const onLoadCompleteCB = (0, $cozmU.useCallback)(()=>{
        onLoadComplete();
        setLoading(false);
    }, [
        onLoadComplete,
        setLoading
    ]);
    const onCloseCB = (0, $cozmU.useCallback)(()=>{
        showExtension(null);
    }, [
        showExtension
    ]);
    const onForgeExtensionClick = (0, $cozmU.useCallback)((ext)=>{
        experienceTracker.start({
            name: $0c33e41081c1500e$var$EXPERIENCE_NAME,
            id: ext.id,
            timeout: 10000
        });
        showExtension(ext);
        setLoading(true);
    }, [
        showExtension,
        setLoading,
        experienceTracker
    ]);
    // shows up when preloaded in SSR. Shows up again when SPA takes over bf all queries are loaded.
    const LazyLoader = (0, $cozmU.useMemo)(()=>(0, $dizL5.lazyForgeUIExtensionsWithLoader)(()=>lazyLoaderPlaceholderComponent ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9MrOn.ContentToolsButton // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
            ), {
                isDisabled: !(window.__SSR_RENDERED__ || undefined)
            })), // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, loadExtension && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0c33e41081c1500e$var$ForgeUIExtensionLoader, {
        extension: extension,
        contentId: contentId,
        spaceKey: spaceKey,
        onLoadComplete: onLoadCompleteCB,
        onClose: onCloseCB
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(LazyLoader, {
        moduleType: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
        render: (extensions, loading, error)=>{
            if (loading) return children([]);
            if (error) {
                if (!(0, $7Sm4c.isErrorMarkedAsHandled)(error)) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                    attribution: (0, $3IBnw.Attribution).ECOSYSTEM
                });
                return children([]);
            }
            const result = extensions.map((ext)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ced39bfea5ef5993$export$9f275aff884e1431), {
                    key: ext.id,
                    extension: ext,
                    onClick: onForgeExtensionClick,
                    isLoading: extension === ext
                }));
            return children(result);
        }
    }));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0c33e41081c1500e$var$InvisibleDiv = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1e0cglyw",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); /**
     * LazyForgeUIExtension has its own loading spinner, however, we don't want to show it anywhere. We want to show a
     * loading spinner inside the menu item while loading the extension, and then close the menu once the loading is complete.
     * To accomplish that, we're rendering LazyForgeUIExtension inside an invisible div.
     * @param forgeExtension To be loaded.
     * @param contentId Passed down to ForgeUIExtension both contentId and spaceKey becomes available in the forge app with
     * `useProductContext` hook. For reference https://developer.atlassian.com/platform/forge/ui-hooks-reference/.
     * @param spaceKey Passed down to ForgeUIExtension.
     * @param onLoadComplete Triggered when the forge extension is loaded.
     * @param onClose Triggered when the rendered ModalDialog is closed. (Currently ContentAction forge component can only contain a ModalDialog)
     * @returns LazyForgeUIExtension inside an InvisibleDiv.
     * @constructor
     */ 
function $0c33e41081c1500e$var$ForgeUIExtensionLoader(t0) {
    const $ = (0, $bDgLe.c)(33);
    const { extension: extension, contentId: contentId, spaceKey: spaceAlias, onLoadComplete: onLoadComplete, onClose: onClose } = t0;
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [t1] = (0, $ep3mz.usePageState)();
    const { routeName: routeName } = t1;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { activationId: activationId } = (0, $bQm3c.useSessionData)();
    const { spaceId: spaceId, spaceKey: spaceKey } = (0, $6uUjl.useSpaceIdentifiers)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { setIsCloseMenuDisabled: setIsCloseMenuDisabled } = (0, $c54hr.useMoreActionsMenuActions)();
    let t2;
    let t3;
    if ($[0] !== setIsCloseMenuDisabled) {
        t2 = ()=>{
            setIsCloseMenuDisabled(true);
            return ()=>{
                setIsCloseMenuDisabled(false);
            };
        };
        t3 = [
            setIsCloseMenuDisabled
        ];
        $[0] = setIsCloseMenuDisabled;
        $[1] = t2;
        $[2] = t3;
    } else {
        t2 = $[1];
        t3 = $[2];
    }
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    if ($[3] !== activationId || $[4] !== contentId || $[5] !== createAnalyticsEvent || $[6] !== experienceTracker || $[7] !== extension || $[8] !== onLoadComplete || $[9] !== routeName || $[10] !== spaceAlias || $[11] !== spaceId) {
        t4 = ()=>{
            experienceTracker.succeed({
                name: $0c33e41081c1500e$var$EXPERIENCE_NAME
            });
            onLoadComplete();
            const appId = (0, $8a9Dm.getAppId)(extension);
            const analyticEvent = createAnalyticsEvent({
                type: "sendTrackEvent",
                data: {
                    action: "invoked",
                    actionSubject: "forgeExtension",
                    actionSubjectId: appId,
                    containerType: "space",
                    containerId: spaceId,
                    objectType: (0, $hIaUw.getContentType)(routeName),
                    objectId: contentId,
                    source: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                    attributes: {
                        activationId: activationId,
                        appId: appId,
                        moduleType: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                        moduleKey: (0, $8a9Dm.getModuleKey)(extension),
                        spaceType: (0, $6UqI3.getSpaceType)(spaceAlias),
                        spaceId: spaceId
                    }
                }
            });
            analyticEvent.fire();
        };
        $[3] = activationId;
        $[4] = contentId;
        $[5] = createAnalyticsEvent;
        $[6] = experienceTracker;
        $[7] = extension;
        $[8] = onLoadComplete;
        $[9] = routeName;
        $[10] = spaceAlias;
        $[11] = spaceId;
        $[12] = t4;
    } else t4 = $[12];
    const onInitialRender = t4;
    if (!spaceKey) return null;
    const t5 = extension.id;
    const t6 = isLivePage ? "live" : null;
    let t7;
    if ($[13] !== routeName) {
        t7 = (0, $hIaUw.getContentType)(routeName);
        $[13] = routeName;
        $[14] = t7;
    } else t7 = $[14];
    let t8;
    if ($[15] !== contentId || $[16] !== t6 || $[17] !== t7) {
        t8 = {
            id: contentId,
            subtype: t6,
            type: t7
        };
        $[15] = contentId;
        $[16] = t6;
        $[17] = t7;
        $[18] = t8;
    } else t8 = $[18];
    const t9 = spaceKey || spaceAlias;
    let t10;
    if ($[19] !== spaceId || $[20] !== t9) {
        t10 = {
            key: t9,
            id: spaceId
        };
        $[19] = spaceId;
        $[20] = t9;
        $[21] = t10;
    } else t10 = $[21];
    let t11;
    if ($[22] !== t10 || $[23] !== t8) {
        t11 = {
            type: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
            content: t8,
            space: t10
        };
        $[22] = t10;
        $[23] = t8;
        $[24] = t11;
    } else t11 = $[24];
    let t12;
    if ($[25] !== onClose || $[26] !== setIsCloseMenuDisabled) {
        t12 = ()=>{
            setIsCloseMenuDisabled(false);
            onClose();
        };
        $[25] = onClose;
        $[26] = setIsCloseMenuDisabled;
        $[27] = t12;
    } else t12 = $[27];
    let t13;
    if ($[28] !== extension || $[29] !== onInitialRender || $[30] !== t11 || $[31] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0c33e41081c1500e$var$InvisibleDiv, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7QUD1.ContentActionForgeApp), {
            key: t5,
            app: extension,
            extensionData: t11,
            onInitialRender: onInitialRender,
            onTearDown: t12
        }));
        $[28] = extension;
        $[29] = onInitialRender;
        $[30] = t11;
        $[31] = t12;
        $[32] = t13;
    } else t13 = $[32];
    return t13;
}
$0c33e41081c1500e$var$ForgeUIExtensionLoader.propTypes = {
    extension: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).object.isRequired,
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string.isRequired,
    spaceKey: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string.isRequired,
    onLoadComplete: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).func.isRequired,
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).func.isRequired
};
module.exports["ForgeContentTools"] = $0c33e41081c1500e$export$7cf22b806dbb23cb;

});

parcelRegister("7Ndnw", function(module, exports) {
const $af2b0e533822f413$export$77aa6bcc53373193 = 'confluence:contentBylineItem';
const $af2b0e533822f413$export$dfd79dc5aae7414d = 'confluence:contextMenu';
const $af2b0e533822f413$export$93827e7f1bb6974c = 'confluence:contentAction';
const $af2b0e533822f413$export$6a8e7521883fbbdb = 'confluence:fullPage';
const $af2b0e533822f413$export$931827627b89a6ba = 'confluence:globalPage';
const $af2b0e533822f413$export$109ae14a8174901f = 'confluence:globalSettings';
const $af2b0e533822f413$export$e31530da5c277984 = 'confluence:homepageFeed';
const $af2b0e533822f413$export$54edc26d40e1a8eb = 'confluence:pageBanner';
const $af2b0e533822f413$export$75695e15f2aab495 = 'confluence:spacePage';
const $af2b0e533822f413$export$f17386882264cfae = 'confluence:spaceSettings';
const $af2b0e533822f413$export$3e9f3e416c5066aa = 'confluence:customContent';
const $af2b0e533822f413$export$b9c5c98eb97dff92 = 'confluence:backgroundScript';
const $af2b0e533822f413$export$c0df8ab57c5edc2a = 'test:module';
const $af2b0e533822f413$export$769f3a278705a683 = 'xen:macro';
const $af2b0e533822f413$export$492ceb220fc48ad2 = [
    $af2b0e533822f413$export$6a8e7521883fbbdb,
    $af2b0e533822f413$export$931827627b89a6ba,
    $af2b0e533822f413$export$109ae14a8174901f,
    $af2b0e533822f413$export$e31530da5c277984,
    $af2b0e533822f413$export$b9c5c98eb97dff92
];
const $af2b0e533822f413$export$ec6cdf0e930aca0a = [
    $af2b0e533822f413$export$75695e15f2aab495,
    $af2b0e533822f413$export$f17386882264cfae,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
const $af2b0e533822f413$export$344b997b63ff6612 = [
    $af2b0e533822f413$export$77aa6bcc53373193,
    $af2b0e533822f413$export$dfd79dc5aae7414d,
    $af2b0e533822f413$export$93827e7f1bb6974c,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
module.exports["FORGE_MODULE_BYLINE"] = $af2b0e533822f413$export$77aa6bcc53373193;
module.exports["FORGE_MODULE_CONTEXT_MENU"] = $af2b0e533822f413$export$dfd79dc5aae7414d;
module.exports["FORGE_MODULE_CONTENT_ACTION"] = $af2b0e533822f413$export$93827e7f1bb6974c;
module.exports["FORGE_MODULE_GLOBAL_PAGE"] = $af2b0e533822f413$export$931827627b89a6ba;
module.exports["FORGE_MODULE_GLOBAL_SETTINGS"] = $af2b0e533822f413$export$109ae14a8174901f;
module.exports["FORGE_MODULE_HOMEPAGE_FEED"] = $af2b0e533822f413$export$e31530da5c277984;
module.exports["FORGE_MODULE_PAGE_BANNER"] = $af2b0e533822f413$export$54edc26d40e1a8eb;
module.exports["FORGE_MODULE_SPACE_PAGE"] = $af2b0e533822f413$export$75695e15f2aab495;
module.exports["FORGE_MODULE_SPACE_SETTINGS"] = $af2b0e533822f413$export$f17386882264cfae;
module.exports["FORGE_MODULE_CUSTOM_CONTENT"] = $af2b0e533822f413$export$3e9f3e416c5066aa;
module.exports["FORGE_MODULE_BACKGROUND_SCRIPT"] = $af2b0e533822f413$export$b9c5c98eb97dff92;
module.exports["FORGE_MODULE_XEN_MACRO"] = $af2b0e533822f413$export$769f3a278705a683;

});

parcelRegister("7QUD1", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $02976f123c8f8e25$export$d2159b9f3f077903 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "cPPBg",
    name: "ByLineForgeApp",
    loader: async ()=>(await (parcelRequire("9LZGw"))).ByLineForgeApp
});

const $02976f123c8f8e25$export$f900958ce7c4410f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "uUYc7",
    name: "ContentActionForgeApp",
    loader: async ()=>(await (parcelRequire("2yswc"))).ContentActionForgeApp
});

const $02976f123c8f8e25$export$79ed117743c6c2cf = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "YSsGA",
    name: "ContextMenuForgeApp",
    loader: async ()=>(await (parcelRequire("1ftKD"))).ContextMenuForgeApp
});

const $02976f123c8f8e25$export$b8ad4f58faf0ae = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "AI3JE",
    name: "FullPageForgeApp",
    loader: async ()=>(await (parcelRequire("7TwPL"))).FullPageForgeApp
});

const $02976f123c8f8e25$export$83db8797814193a8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "HPVuo",
    name: "GlobalPageForgeApp",
    loader: async ()=>(await (parcelRequire("jBCZ3"))).GlobalPageForgeApp
});

const $02976f123c8f8e25$export$74528162c4c3828b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "iEsk7",
    name: "GlobalSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("hwTh0"))).GlobalSettingsForgeApp
});

const $02976f123c8f8e25$export$c8291e2d6d6adbf2 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "MWvHM",
    name: "HomepageFeedForgeApp",
    loader: async ()=>(await (parcelRequire("9yZxZ"))).HomepageFeedForgeApp
});

const $02976f123c8f8e25$export$e8858129e933f7e8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "KHgoO",
    name: "SpaceSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("2Q3ms"))).SpaceSettingsForgeApp
});

const $02976f123c8f8e25$export$60a905140138a1c8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-3RXI",
    name: "SpacePageForgeApp",
    loader: async ()=>(await (parcelRequire("3VcYD"))).SpacePageForgeApp
});

const $02976f123c8f8e25$export$578d0cbdb0ffa72e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "9Auod",
    name: "CustomContentForgeApp",
    loader: async ()=>(await (parcelRequire("3sEbo"))).CustomContentForgeApp
});

const $02976f123c8f8e25$export$40d4b5cfa6c18ea7 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "zkdSh",
    name: "BackgroundScriptForgeApp",
    loader: async ()=>(await (parcelRequire("5h1CY"))).BackgroundScriptForgeApp
});

const $02976f123c8f8e25$export$c76787f94e0b1609 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "BA7en",
    name: "PageBannerForgeApp",
    loader: async ()=>(await (parcelRequire("caBdd"))).PageBannerForgeApp
});
module.exports["ByLineForgeApp"] = $02976f123c8f8e25$export$d2159b9f3f077903;
module.exports["ContentActionForgeApp"] = $02976f123c8f8e25$export$f900958ce7c4410f;
module.exports["ContextMenuForgeApp"] = $02976f123c8f8e25$export$79ed117743c6c2cf;
module.exports["GlobalPageForgeApp"] = $02976f123c8f8e25$export$83db8797814193a8;
module.exports["GlobalSettingsForgeApp"] = $02976f123c8f8e25$export$74528162c4c3828b;
module.exports["HomepageFeedForgeApp"] = $02976f123c8f8e25$export$c8291e2d6d6adbf2;
module.exports["SpaceSettingsForgeApp"] = $02976f123c8f8e25$export$e8858129e933f7e8;
module.exports["SpacePageForgeApp"] = $02976f123c8f8e25$export$60a905140138a1c8;
module.exports["CustomContentForgeApp"] = $02976f123c8f8e25$export$578d0cbdb0ffa72e;
module.exports["BackgroundScriptForgeApp"] = $02976f123c8f8e25$export$40d4b5cfa6c18ea7;
module.exports["PageBannerForgeApp"] = $02976f123c8f8e25$export$c76787f94e0b1609;

});

parcelRegister("9LZGw", function(module, exports) {

let $71d85a2c055014ec$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $71d85a2c055014ec$var$load("hUbK8"),
    $71d85a2c055014ec$var$load("eNXrl"),
    $71d85a2c055014ec$var$load("eyY0h"),
    $71d85a2c055014ec$var$load("5HweM"),
    $71d85a2c055014ec$var$load("1Gr4q"),
    $71d85a2c055014ec$var$load("cPAXo"),
    $71d85a2c055014ec$var$load("44j0l"),
    $71d85a2c055014ec$var$load("7G12e"),
    $71d85a2c055014ec$var$load("7oAXW"),
    $71d85a2c055014ec$var$load("LWh5V"),
    $71d85a2c055014ec$var$load("gbejv"),
    $71d85a2c055014ec$var$load("GD9EA"),
    $71d85a2c055014ec$var$load("h4Nf7"),
    $71d85a2c055014ec$var$load("4XkGy"),
    $71d85a2c055014ec$var$load("kHXvF"),
    $71d85a2c055014ec$var$load("fuOfV"),
    $71d85a2c055014ec$var$load("iZR3N"),
    $71d85a2c055014ec$var$load("jXM1T"),
    $71d85a2c055014ec$var$load("cvcNg"),
    $71d85a2c055014ec$var$load("4N1MY"),
    $71d85a2c055014ec$var$load("jL1Ke"),
    $71d85a2c055014ec$var$load("5MQ0D"),
    $71d85a2c055014ec$var$load("iNoxQ"),
    $71d85a2c055014ec$var$load("lOm4J"),
    $71d85a2c055014ec$var$load("6wr18"),
    $71d85a2c055014ec$var$load("59hV4"),
    $71d85a2c055014ec$var$load("8zMmc"),
    $71d85a2c055014ec$var$load("4x9Jx"),
    $71d85a2c055014ec$var$load("ffEVr"),
    $71d85a2c055014ec$var$load("eCXJR"),
    $71d85a2c055014ec$var$load("1VTX2"),
    $71d85a2c055014ec$var$load("jZMUd"),
    $71d85a2c055014ec$var$load("2EIkU"),
    $71d85a2c055014ec$var$load("7TnhR"),
    $71d85a2c055014ec$var$load("ddvkk"),
    $71d85a2c055014ec$var$load("3upHR"),
    $71d85a2c055014ec$var$load("dBHUb"),
    $71d85a2c055014ec$var$load("5Rx9J"),
    $71d85a2c055014ec$var$load("Wowvf"),
    $71d85a2c055014ec$var$load("eRhBr"),
    $71d85a2c055014ec$var$load("6HpsR"),
    $71d85a2c055014ec$var$load("N3oqb"),
    $71d85a2c055014ec$var$load("hZ2FX"),
    $71d85a2c055014ec$var$load("hhss7"),
    $71d85a2c055014ec$var$load("1NGPq"),
    $71d85a2c055014ec$var$load("lnKog"),
    $71d85a2c055014ec$var$load("kT6dz"),
    $71d85a2c055014ec$var$load("aAWLw"),
    $71d85a2c055014ec$var$load("7EorR"),
    $71d85a2c055014ec$var$load("bGzhS")
]).then(()=>parcelRequire('5soYL'));

});

parcelRegister("2yswc", function(module, exports) {

let $1dc4e0e3dbe05f39$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $1dc4e0e3dbe05f39$var$load("hUbK8"),
    $1dc4e0e3dbe05f39$var$load("eNXrl"),
    $1dc4e0e3dbe05f39$var$load("eyY0h"),
    $1dc4e0e3dbe05f39$var$load("5HweM"),
    $1dc4e0e3dbe05f39$var$load("1Gr4q"),
    $1dc4e0e3dbe05f39$var$load("cPAXo"),
    $1dc4e0e3dbe05f39$var$load("44j0l"),
    $1dc4e0e3dbe05f39$var$load("7G12e"),
    $1dc4e0e3dbe05f39$var$load("7oAXW"),
    $1dc4e0e3dbe05f39$var$load("LWh5V"),
    $1dc4e0e3dbe05f39$var$load("gbejv"),
    $1dc4e0e3dbe05f39$var$load("GD9EA"),
    $1dc4e0e3dbe05f39$var$load("h4Nf7"),
    $1dc4e0e3dbe05f39$var$load("4XkGy"),
    $1dc4e0e3dbe05f39$var$load("kHXvF"),
    $1dc4e0e3dbe05f39$var$load("fuOfV"),
    $1dc4e0e3dbe05f39$var$load("iZR3N"),
    $1dc4e0e3dbe05f39$var$load("jXM1T"),
    $1dc4e0e3dbe05f39$var$load("cvcNg"),
    $1dc4e0e3dbe05f39$var$load("4N1MY"),
    $1dc4e0e3dbe05f39$var$load("jL1Ke"),
    $1dc4e0e3dbe05f39$var$load("5MQ0D"),
    $1dc4e0e3dbe05f39$var$load("iNoxQ"),
    $1dc4e0e3dbe05f39$var$load("lOm4J"),
    $1dc4e0e3dbe05f39$var$load("6wr18"),
    $1dc4e0e3dbe05f39$var$load("59hV4"),
    $1dc4e0e3dbe05f39$var$load("8zMmc"),
    $1dc4e0e3dbe05f39$var$load("4x9Jx"),
    $1dc4e0e3dbe05f39$var$load("ffEVr"),
    $1dc4e0e3dbe05f39$var$load("eCXJR"),
    $1dc4e0e3dbe05f39$var$load("1VTX2"),
    $1dc4e0e3dbe05f39$var$load("jZMUd"),
    $1dc4e0e3dbe05f39$var$load("2EIkU"),
    $1dc4e0e3dbe05f39$var$load("7TnhR"),
    $1dc4e0e3dbe05f39$var$load("ddvkk"),
    $1dc4e0e3dbe05f39$var$load("3upHR"),
    $1dc4e0e3dbe05f39$var$load("dBHUb"),
    $1dc4e0e3dbe05f39$var$load("5Rx9J"),
    $1dc4e0e3dbe05f39$var$load("Wowvf"),
    $1dc4e0e3dbe05f39$var$load("eRhBr"),
    $1dc4e0e3dbe05f39$var$load("6HpsR"),
    $1dc4e0e3dbe05f39$var$load("N3oqb"),
    $1dc4e0e3dbe05f39$var$load("hZ2FX"),
    $1dc4e0e3dbe05f39$var$load("hhss7"),
    $1dc4e0e3dbe05f39$var$load("1NGPq"),
    $1dc4e0e3dbe05f39$var$load("lnKog"),
    $1dc4e0e3dbe05f39$var$load("kT6dz"),
    $1dc4e0e3dbe05f39$var$load("aAWLw"),
    $1dc4e0e3dbe05f39$var$load("7EorR"),
    $1dc4e0e3dbe05f39$var$load("bdzih")
]).then(()=>parcelRequire('kXBs1'));

});

parcelRegister("1ftKD", function(module, exports) {

let $0e8e45241504a29b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $0e8e45241504a29b$var$load("hUbK8"),
    $0e8e45241504a29b$var$load("eNXrl"),
    $0e8e45241504a29b$var$load("eyY0h"),
    $0e8e45241504a29b$var$load("5HweM"),
    $0e8e45241504a29b$var$load("1Gr4q"),
    $0e8e45241504a29b$var$load("cPAXo"),
    $0e8e45241504a29b$var$load("44j0l"),
    $0e8e45241504a29b$var$load("7G12e"),
    $0e8e45241504a29b$var$load("7oAXW"),
    $0e8e45241504a29b$var$load("LWh5V"),
    $0e8e45241504a29b$var$load("gbejv"),
    $0e8e45241504a29b$var$load("GD9EA"),
    $0e8e45241504a29b$var$load("h4Nf7"),
    $0e8e45241504a29b$var$load("4XkGy"),
    $0e8e45241504a29b$var$load("kHXvF"),
    $0e8e45241504a29b$var$load("fuOfV"),
    $0e8e45241504a29b$var$load("iZR3N"),
    $0e8e45241504a29b$var$load("jXM1T"),
    $0e8e45241504a29b$var$load("cvcNg"),
    $0e8e45241504a29b$var$load("4N1MY"),
    $0e8e45241504a29b$var$load("jL1Ke"),
    $0e8e45241504a29b$var$load("5MQ0D"),
    $0e8e45241504a29b$var$load("iNoxQ"),
    $0e8e45241504a29b$var$load("lOm4J"),
    $0e8e45241504a29b$var$load("6wr18"),
    $0e8e45241504a29b$var$load("59hV4"),
    $0e8e45241504a29b$var$load("8zMmc"),
    $0e8e45241504a29b$var$load("4x9Jx"),
    $0e8e45241504a29b$var$load("ffEVr"),
    $0e8e45241504a29b$var$load("eCXJR"),
    $0e8e45241504a29b$var$load("1VTX2"),
    $0e8e45241504a29b$var$load("jZMUd"),
    $0e8e45241504a29b$var$load("2EIkU"),
    $0e8e45241504a29b$var$load("7TnhR"),
    $0e8e45241504a29b$var$load("ddvkk"),
    $0e8e45241504a29b$var$load("3upHR"),
    $0e8e45241504a29b$var$load("dBHUb"),
    $0e8e45241504a29b$var$load("5Rx9J"),
    $0e8e45241504a29b$var$load("Wowvf"),
    $0e8e45241504a29b$var$load("eRhBr"),
    $0e8e45241504a29b$var$load("6HpsR"),
    $0e8e45241504a29b$var$load("N3oqb"),
    $0e8e45241504a29b$var$load("hZ2FX"),
    $0e8e45241504a29b$var$load("hhss7"),
    $0e8e45241504a29b$var$load("1NGPq"),
    $0e8e45241504a29b$var$load("lnKog"),
    $0e8e45241504a29b$var$load("kT6dz"),
    $0e8e45241504a29b$var$load("aAWLw"),
    $0e8e45241504a29b$var$load("7EorR"),
    $0e8e45241504a29b$var$load("cwpVK")
]).then(()=>parcelRequire('1yxl3'));

});

parcelRegister("7TwPL", function(module, exports) {

let $5bf72397e613a788$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $5bf72397e613a788$var$load("hUbK8"),
    $5bf72397e613a788$var$load("eyY0h"),
    $5bf72397e613a788$var$load("5HweM"),
    $5bf72397e613a788$var$load("1Gr4q"),
    $5bf72397e613a788$var$load("cPAXo"),
    $5bf72397e613a788$var$load("44j0l"),
    $5bf72397e613a788$var$load("7G12e"),
    $5bf72397e613a788$var$load("7oAXW"),
    $5bf72397e613a788$var$load("gbejv"),
    $5bf72397e613a788$var$load("GD9EA"),
    $5bf72397e613a788$var$load("h4Nf7"),
    $5bf72397e613a788$var$load("kHXvF"),
    $5bf72397e613a788$var$load("iZR3N"),
    $5bf72397e613a788$var$load("jXM1T"),
    $5bf72397e613a788$var$load("cvcNg"),
    $5bf72397e613a788$var$load("6wr18"),
    $5bf72397e613a788$var$load("4N1MY"),
    $5bf72397e613a788$var$load("8zMmc"),
    $5bf72397e613a788$var$load("4x9Jx"),
    $5bf72397e613a788$var$load("ffEVr"),
    $5bf72397e613a788$var$load("eCXJR"),
    $5bf72397e613a788$var$load("1VTX2"),
    $5bf72397e613a788$var$load("jZMUd"),
    $5bf72397e613a788$var$load("2EIkU"),
    $5bf72397e613a788$var$load("1NGPq"),
    $5bf72397e613a788$var$load("7TnhR"),
    $5bf72397e613a788$var$load("ddvkk"),
    $5bf72397e613a788$var$load("3upHR"),
    $5bf72397e613a788$var$load("dBHUb"),
    $5bf72397e613a788$var$load("5Rx9J"),
    $5bf72397e613a788$var$load("Wowvf"),
    $5bf72397e613a788$var$load("eRhBr"),
    $5bf72397e613a788$var$load("6HpsR"),
    $5bf72397e613a788$var$load("N3oqb"),
    $5bf72397e613a788$var$load("hZ2FX"),
    $5bf72397e613a788$var$load("hhss7"),
    $5bf72397e613a788$var$load("kT6dz"),
    $5bf72397e613a788$var$load("aAWLw"),
    $5bf72397e613a788$var$load("7EorR"),
    $5bf72397e613a788$var$load("68RC4")
]).then(()=>parcelRequire('f6dwD'));

});

parcelRegister("jBCZ3", function(module, exports) {

let $e45fb6600b54d24e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $e45fb6600b54d24e$var$load("hUbK8"),
    $e45fb6600b54d24e$var$load("eyY0h"),
    $e45fb6600b54d24e$var$load("5HweM"),
    $e45fb6600b54d24e$var$load("1Gr4q"),
    $e45fb6600b54d24e$var$load("cPAXo"),
    $e45fb6600b54d24e$var$load("44j0l"),
    $e45fb6600b54d24e$var$load("7G12e"),
    $e45fb6600b54d24e$var$load("7oAXW"),
    $e45fb6600b54d24e$var$load("gbejv"),
    $e45fb6600b54d24e$var$load("GD9EA"),
    $e45fb6600b54d24e$var$load("h4Nf7"),
    $e45fb6600b54d24e$var$load("kHXvF"),
    $e45fb6600b54d24e$var$load("iZR3N"),
    $e45fb6600b54d24e$var$load("jXM1T"),
    $e45fb6600b54d24e$var$load("cvcNg"),
    $e45fb6600b54d24e$var$load("6wr18"),
    $e45fb6600b54d24e$var$load("4N1MY"),
    $e45fb6600b54d24e$var$load("8zMmc"),
    $e45fb6600b54d24e$var$load("4x9Jx"),
    $e45fb6600b54d24e$var$load("ffEVr"),
    $e45fb6600b54d24e$var$load("eCXJR"),
    $e45fb6600b54d24e$var$load("1VTX2"),
    $e45fb6600b54d24e$var$load("jZMUd"),
    $e45fb6600b54d24e$var$load("2EIkU"),
    $e45fb6600b54d24e$var$load("1NGPq"),
    $e45fb6600b54d24e$var$load("7TnhR"),
    $e45fb6600b54d24e$var$load("ddvkk"),
    $e45fb6600b54d24e$var$load("3upHR"),
    $e45fb6600b54d24e$var$load("dBHUb"),
    $e45fb6600b54d24e$var$load("5Rx9J"),
    $e45fb6600b54d24e$var$load("Wowvf"),
    $e45fb6600b54d24e$var$load("eRhBr"),
    $e45fb6600b54d24e$var$load("6HpsR"),
    $e45fb6600b54d24e$var$load("N3oqb"),
    $e45fb6600b54d24e$var$load("hZ2FX"),
    $e45fb6600b54d24e$var$load("hhss7"),
    $e45fb6600b54d24e$var$load("kT6dz"),
    $e45fb6600b54d24e$var$load("aAWLw"),
    $e45fb6600b54d24e$var$load("7EorR"),
    $e45fb6600b54d24e$var$load("87cDu")
]).then(()=>parcelRequire('iChZx'));

});

parcelRegister("hwTh0", function(module, exports) {

let $cc304cef23016eb0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $cc304cef23016eb0$var$load("hUbK8"),
    $cc304cef23016eb0$var$load("eyY0h"),
    $cc304cef23016eb0$var$load("5HweM"),
    $cc304cef23016eb0$var$load("1Gr4q"),
    $cc304cef23016eb0$var$load("cPAXo"),
    $cc304cef23016eb0$var$load("44j0l"),
    $cc304cef23016eb0$var$load("7G12e"),
    $cc304cef23016eb0$var$load("7oAXW"),
    $cc304cef23016eb0$var$load("gbejv"),
    $cc304cef23016eb0$var$load("GD9EA"),
    $cc304cef23016eb0$var$load("h4Nf7"),
    $cc304cef23016eb0$var$load("kHXvF"),
    $cc304cef23016eb0$var$load("iZR3N"),
    $cc304cef23016eb0$var$load("jXM1T"),
    $cc304cef23016eb0$var$load("cvcNg"),
    $cc304cef23016eb0$var$load("6wr18"),
    $cc304cef23016eb0$var$load("4N1MY"),
    $cc304cef23016eb0$var$load("8zMmc"),
    $cc304cef23016eb0$var$load("4x9Jx"),
    $cc304cef23016eb0$var$load("ffEVr"),
    $cc304cef23016eb0$var$load("eCXJR"),
    $cc304cef23016eb0$var$load("1VTX2"),
    $cc304cef23016eb0$var$load("jZMUd"),
    $cc304cef23016eb0$var$load("2EIkU"),
    $cc304cef23016eb0$var$load("1NGPq"),
    $cc304cef23016eb0$var$load("7TnhR"),
    $cc304cef23016eb0$var$load("ddvkk"),
    $cc304cef23016eb0$var$load("3upHR"),
    $cc304cef23016eb0$var$load("dBHUb"),
    $cc304cef23016eb0$var$load("5Rx9J"),
    $cc304cef23016eb0$var$load("Wowvf"),
    $cc304cef23016eb0$var$load("eRhBr"),
    $cc304cef23016eb0$var$load("6HpsR"),
    $cc304cef23016eb0$var$load("N3oqb"),
    $cc304cef23016eb0$var$load("hZ2FX"),
    $cc304cef23016eb0$var$load("hhss7"),
    $cc304cef23016eb0$var$load("kT6dz"),
    $cc304cef23016eb0$var$load("aAWLw"),
    $cc304cef23016eb0$var$load("7EorR"),
    $cc304cef23016eb0$var$load("iXr0W")
]).then(()=>parcelRequire('671JL'));

});

parcelRegister("9yZxZ", function(module, exports) {

let $6f670802005df0b9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $6f670802005df0b9$var$load("hUbK8"),
    $6f670802005df0b9$var$load("eyY0h"),
    $6f670802005df0b9$var$load("5HweM"),
    $6f670802005df0b9$var$load("1Gr4q"),
    $6f670802005df0b9$var$load("cPAXo"),
    $6f670802005df0b9$var$load("44j0l"),
    $6f670802005df0b9$var$load("7G12e"),
    $6f670802005df0b9$var$load("7oAXW"),
    $6f670802005df0b9$var$load("gbejv"),
    $6f670802005df0b9$var$load("GD9EA"),
    $6f670802005df0b9$var$load("h4Nf7"),
    $6f670802005df0b9$var$load("kHXvF"),
    $6f670802005df0b9$var$load("iZR3N"),
    $6f670802005df0b9$var$load("jXM1T"),
    $6f670802005df0b9$var$load("cvcNg"),
    $6f670802005df0b9$var$load("6wr18"),
    $6f670802005df0b9$var$load("4N1MY"),
    $6f670802005df0b9$var$load("8zMmc"),
    $6f670802005df0b9$var$load("4x9Jx"),
    $6f670802005df0b9$var$load("ffEVr"),
    $6f670802005df0b9$var$load("eCXJR"),
    $6f670802005df0b9$var$load("1VTX2"),
    $6f670802005df0b9$var$load("jZMUd"),
    $6f670802005df0b9$var$load("2EIkU"),
    $6f670802005df0b9$var$load("7TnhR"),
    $6f670802005df0b9$var$load("ddvkk"),
    $6f670802005df0b9$var$load("3upHR"),
    $6f670802005df0b9$var$load("dBHUb"),
    $6f670802005df0b9$var$load("5Rx9J"),
    $6f670802005df0b9$var$load("Wowvf"),
    $6f670802005df0b9$var$load("eRhBr"),
    $6f670802005df0b9$var$load("6HpsR"),
    $6f670802005df0b9$var$load("N3oqb"),
    $6f670802005df0b9$var$load("hZ2FX"),
    $6f670802005df0b9$var$load("hhss7"),
    $6f670802005df0b9$var$load("1NGPq"),
    $6f670802005df0b9$var$load("lnKog"),
    $6f670802005df0b9$var$load("kT6dz"),
    $6f670802005df0b9$var$load("aAWLw"),
    $6f670802005df0b9$var$load("7EorR"),
    $6f670802005df0b9$var$load("ccJug")
]).then(()=>parcelRequire('k3MMo'));

});

parcelRegister("2Q3ms", function(module, exports) {

let $21130b9595a23f3d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $21130b9595a23f3d$var$load("hUbK8"),
    $21130b9595a23f3d$var$load("eyY0h"),
    $21130b9595a23f3d$var$load("5HweM"),
    $21130b9595a23f3d$var$load("1Gr4q"),
    $21130b9595a23f3d$var$load("cPAXo"),
    $21130b9595a23f3d$var$load("44j0l"),
    $21130b9595a23f3d$var$load("7G12e"),
    $21130b9595a23f3d$var$load("7oAXW"),
    $21130b9595a23f3d$var$load("gbejv"),
    $21130b9595a23f3d$var$load("GD9EA"),
    $21130b9595a23f3d$var$load("h4Nf7"),
    $21130b9595a23f3d$var$load("4XkGy"),
    $21130b9595a23f3d$var$load("kHXvF"),
    $21130b9595a23f3d$var$load("fuOfV"),
    $21130b9595a23f3d$var$load("iZR3N"),
    $21130b9595a23f3d$var$load("jXM1T"),
    $21130b9595a23f3d$var$load("cvcNg"),
    $21130b9595a23f3d$var$load("4N1MY"),
    $21130b9595a23f3d$var$load("jL1Ke"),
    $21130b9595a23f3d$var$load("5MQ0D"),
    $21130b9595a23f3d$var$load("iNoxQ"),
    $21130b9595a23f3d$var$load("lOm4J"),
    $21130b9595a23f3d$var$load("6wr18"),
    $21130b9595a23f3d$var$load("59hV4"),
    $21130b9595a23f3d$var$load("8zMmc"),
    $21130b9595a23f3d$var$load("4x9Jx"),
    $21130b9595a23f3d$var$load("ffEVr"),
    $21130b9595a23f3d$var$load("eCXJR"),
    $21130b9595a23f3d$var$load("1VTX2"),
    $21130b9595a23f3d$var$load("jZMUd"),
    $21130b9595a23f3d$var$load("2EIkU"),
    $21130b9595a23f3d$var$load("7TnhR"),
    $21130b9595a23f3d$var$load("ddvkk"),
    $21130b9595a23f3d$var$load("3upHR"),
    $21130b9595a23f3d$var$load("dBHUb"),
    $21130b9595a23f3d$var$load("5Rx9J"),
    $21130b9595a23f3d$var$load("Wowvf"),
    $21130b9595a23f3d$var$load("eRhBr"),
    $21130b9595a23f3d$var$load("6HpsR"),
    $21130b9595a23f3d$var$load("N3oqb"),
    $21130b9595a23f3d$var$load("hZ2FX"),
    $21130b9595a23f3d$var$load("hhss7"),
    $21130b9595a23f3d$var$load("1NGPq"),
    $21130b9595a23f3d$var$load("lnKog"),
    $21130b9595a23f3d$var$load("kT6dz"),
    $21130b9595a23f3d$var$load("aAWLw"),
    $21130b9595a23f3d$var$load("7EorR"),
    $21130b9595a23f3d$var$load("irYLY")
]).then(()=>parcelRequire('aeos9'));

});

parcelRegister("3VcYD", function(module, exports) {

let $2db0c2f35c08c1ee$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $2db0c2f35c08c1ee$var$load("hUbK8"),
    $2db0c2f35c08c1ee$var$load("eyY0h"),
    $2db0c2f35c08c1ee$var$load("5HweM"),
    $2db0c2f35c08c1ee$var$load("1Gr4q"),
    $2db0c2f35c08c1ee$var$load("cPAXo"),
    $2db0c2f35c08c1ee$var$load("44j0l"),
    $2db0c2f35c08c1ee$var$load("7G12e"),
    $2db0c2f35c08c1ee$var$load("7oAXW"),
    $2db0c2f35c08c1ee$var$load("gbejv"),
    $2db0c2f35c08c1ee$var$load("GD9EA"),
    $2db0c2f35c08c1ee$var$load("h4Nf7"),
    $2db0c2f35c08c1ee$var$load("4XkGy"),
    $2db0c2f35c08c1ee$var$load("kHXvF"),
    $2db0c2f35c08c1ee$var$load("fuOfV"),
    $2db0c2f35c08c1ee$var$load("iZR3N"),
    $2db0c2f35c08c1ee$var$load("jXM1T"),
    $2db0c2f35c08c1ee$var$load("cvcNg"),
    $2db0c2f35c08c1ee$var$load("4N1MY"),
    $2db0c2f35c08c1ee$var$load("jL1Ke"),
    $2db0c2f35c08c1ee$var$load("5MQ0D"),
    $2db0c2f35c08c1ee$var$load("iNoxQ"),
    $2db0c2f35c08c1ee$var$load("lOm4J"),
    $2db0c2f35c08c1ee$var$load("6wr18"),
    $2db0c2f35c08c1ee$var$load("59hV4"),
    $2db0c2f35c08c1ee$var$load("8zMmc"),
    $2db0c2f35c08c1ee$var$load("4x9Jx"),
    $2db0c2f35c08c1ee$var$load("ffEVr"),
    $2db0c2f35c08c1ee$var$load("eCXJR"),
    $2db0c2f35c08c1ee$var$load("1VTX2"),
    $2db0c2f35c08c1ee$var$load("jZMUd"),
    $2db0c2f35c08c1ee$var$load("2EIkU"),
    $2db0c2f35c08c1ee$var$load("7TnhR"),
    $2db0c2f35c08c1ee$var$load("ddvkk"),
    $2db0c2f35c08c1ee$var$load("3upHR"),
    $2db0c2f35c08c1ee$var$load("dBHUb"),
    $2db0c2f35c08c1ee$var$load("5Rx9J"),
    $2db0c2f35c08c1ee$var$load("Wowvf"),
    $2db0c2f35c08c1ee$var$load("eRhBr"),
    $2db0c2f35c08c1ee$var$load("6HpsR"),
    $2db0c2f35c08c1ee$var$load("N3oqb"),
    $2db0c2f35c08c1ee$var$load("hZ2FX"),
    $2db0c2f35c08c1ee$var$load("hhss7"),
    $2db0c2f35c08c1ee$var$load("1NGPq"),
    $2db0c2f35c08c1ee$var$load("lnKog"),
    $2db0c2f35c08c1ee$var$load("kT6dz"),
    $2db0c2f35c08c1ee$var$load("aAWLw"),
    $2db0c2f35c08c1ee$var$load("7EorR"),
    $2db0c2f35c08c1ee$var$load("ldtPf")
]).then(()=>parcelRequire('kWbxC'));

});

parcelRegister("3sEbo", function(module, exports) {

let $285328119473d41b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $285328119473d41b$var$load("hUbK8"),
    $285328119473d41b$var$load("eyY0h"),
    $285328119473d41b$var$load("5HweM"),
    $285328119473d41b$var$load("1Gr4q"),
    $285328119473d41b$var$load("cPAXo"),
    $285328119473d41b$var$load("44j0l"),
    $285328119473d41b$var$load("7G12e"),
    $285328119473d41b$var$load("7oAXW"),
    $285328119473d41b$var$load("gbejv"),
    $285328119473d41b$var$load("GD9EA"),
    $285328119473d41b$var$load("h4Nf7"),
    $285328119473d41b$var$load("kHXvF"),
    $285328119473d41b$var$load("iZR3N"),
    $285328119473d41b$var$load("jXM1T"),
    $285328119473d41b$var$load("cvcNg"),
    $285328119473d41b$var$load("6wr18"),
    $285328119473d41b$var$load("4N1MY"),
    $285328119473d41b$var$load("8zMmc"),
    $285328119473d41b$var$load("4x9Jx"),
    $285328119473d41b$var$load("ffEVr"),
    $285328119473d41b$var$load("eCXJR"),
    $285328119473d41b$var$load("1VTX2"),
    $285328119473d41b$var$load("jZMUd"),
    $285328119473d41b$var$load("2EIkU"),
    $285328119473d41b$var$load("1NGPq"),
    $285328119473d41b$var$load("7TnhR"),
    $285328119473d41b$var$load("ddvkk"),
    $285328119473d41b$var$load("3upHR"),
    $285328119473d41b$var$load("dBHUb"),
    $285328119473d41b$var$load("5Rx9J"),
    $285328119473d41b$var$load("Wowvf"),
    $285328119473d41b$var$load("eRhBr"),
    $285328119473d41b$var$load("6HpsR"),
    $285328119473d41b$var$load("N3oqb"),
    $285328119473d41b$var$load("hZ2FX"),
    $285328119473d41b$var$load("hhss7"),
    $285328119473d41b$var$load("kT6dz"),
    $285328119473d41b$var$load("aAWLw"),
    $285328119473d41b$var$load("7EorR"),
    $285328119473d41b$var$load("6wcNV")
]).then(()=>parcelRequire('iMf0a'));

});

parcelRegister("5h1CY", function(module, exports) {

let $3d6fcd7ff298ade9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $3d6fcd7ff298ade9$var$load("hUbK8"),
    $3d6fcd7ff298ade9$var$load("eyY0h"),
    $3d6fcd7ff298ade9$var$load("5HweM"),
    $3d6fcd7ff298ade9$var$load("1Gr4q"),
    $3d6fcd7ff298ade9$var$load("cPAXo"),
    $3d6fcd7ff298ade9$var$load("44j0l"),
    $3d6fcd7ff298ade9$var$load("7G12e"),
    $3d6fcd7ff298ade9$var$load("7oAXW"),
    $3d6fcd7ff298ade9$var$load("gbejv"),
    $3d6fcd7ff298ade9$var$load("GD9EA"),
    $3d6fcd7ff298ade9$var$load("h4Nf7"),
    $3d6fcd7ff298ade9$var$load("kHXvF"),
    $3d6fcd7ff298ade9$var$load("iZR3N"),
    $3d6fcd7ff298ade9$var$load("jXM1T"),
    $3d6fcd7ff298ade9$var$load("cvcNg"),
    $3d6fcd7ff298ade9$var$load("6wr18"),
    $3d6fcd7ff298ade9$var$load("4N1MY"),
    $3d6fcd7ff298ade9$var$load("8zMmc"),
    $3d6fcd7ff298ade9$var$load("4x9Jx"),
    $3d6fcd7ff298ade9$var$load("ffEVr"),
    $3d6fcd7ff298ade9$var$load("eCXJR"),
    $3d6fcd7ff298ade9$var$load("1VTX2"),
    $3d6fcd7ff298ade9$var$load("jZMUd"),
    $3d6fcd7ff298ade9$var$load("2EIkU"),
    $3d6fcd7ff298ade9$var$load("7TnhR"),
    $3d6fcd7ff298ade9$var$load("ddvkk"),
    $3d6fcd7ff298ade9$var$load("3upHR"),
    $3d6fcd7ff298ade9$var$load("dBHUb"),
    $3d6fcd7ff298ade9$var$load("5Rx9J"),
    $3d6fcd7ff298ade9$var$load("Wowvf"),
    $3d6fcd7ff298ade9$var$load("eRhBr"),
    $3d6fcd7ff298ade9$var$load("6HpsR"),
    $3d6fcd7ff298ade9$var$load("N3oqb"),
    $3d6fcd7ff298ade9$var$load("hZ2FX"),
    $3d6fcd7ff298ade9$var$load("hhss7"),
    $3d6fcd7ff298ade9$var$load("1NGPq"),
    $3d6fcd7ff298ade9$var$load("lnKog"),
    $3d6fcd7ff298ade9$var$load("kT6dz"),
    $3d6fcd7ff298ade9$var$load("aAWLw"),
    $3d6fcd7ff298ade9$var$load("7EorR"),
    $3d6fcd7ff298ade9$var$load("i9jMB")
]).then(()=>parcelRequire('estkk'));

});

parcelRegister("caBdd", function(module, exports) {

let $8dc348bfaf8e5360$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $8dc348bfaf8e5360$var$load("hUbK8"),
    $8dc348bfaf8e5360$var$load("eyY0h"),
    $8dc348bfaf8e5360$var$load("5HweM"),
    $8dc348bfaf8e5360$var$load("1Gr4q"),
    $8dc348bfaf8e5360$var$load("cPAXo"),
    $8dc348bfaf8e5360$var$load("44j0l"),
    $8dc348bfaf8e5360$var$load("7G12e"),
    $8dc348bfaf8e5360$var$load("7oAXW"),
    $8dc348bfaf8e5360$var$load("gbejv"),
    $8dc348bfaf8e5360$var$load("GD9EA"),
    $8dc348bfaf8e5360$var$load("h4Nf7"),
    $8dc348bfaf8e5360$var$load("kHXvF"),
    $8dc348bfaf8e5360$var$load("iZR3N"),
    $8dc348bfaf8e5360$var$load("jXM1T"),
    $8dc348bfaf8e5360$var$load("cvcNg"),
    $8dc348bfaf8e5360$var$load("6wr18"),
    $8dc348bfaf8e5360$var$load("4N1MY"),
    $8dc348bfaf8e5360$var$load("8zMmc"),
    $8dc348bfaf8e5360$var$load("4x9Jx"),
    $8dc348bfaf8e5360$var$load("ffEVr"),
    $8dc348bfaf8e5360$var$load("eCXJR"),
    $8dc348bfaf8e5360$var$load("1VTX2"),
    $8dc348bfaf8e5360$var$load("jZMUd"),
    $8dc348bfaf8e5360$var$load("2EIkU"),
    $8dc348bfaf8e5360$var$load("7TnhR"),
    $8dc348bfaf8e5360$var$load("ddvkk"),
    $8dc348bfaf8e5360$var$load("3upHR"),
    $8dc348bfaf8e5360$var$load("dBHUb"),
    $8dc348bfaf8e5360$var$load("5Rx9J"),
    $8dc348bfaf8e5360$var$load("Wowvf"),
    $8dc348bfaf8e5360$var$load("eRhBr"),
    $8dc348bfaf8e5360$var$load("6HpsR"),
    $8dc348bfaf8e5360$var$load("N3oqb"),
    $8dc348bfaf8e5360$var$load("hZ2FX"),
    $8dc348bfaf8e5360$var$load("hhss7"),
    $8dc348bfaf8e5360$var$load("1NGPq"),
    $8dc348bfaf8e5360$var$load("lnKog"),
    $8dc348bfaf8e5360$var$load("kT6dz"),
    $8dc348bfaf8e5360$var$load("aAWLw"),
    $8dc348bfaf8e5360$var$load("7EorR"),
    $8dc348bfaf8e5360$var$load("aFNXd")
]).then(()=>parcelRequire('cgoGN'));

});

parcelRegister("hIaUw", function(module, exports) {
const $5ff3d548ffdc5eda$export$1ef77878e4e0b972 = (routeName)=>{
    if (routeName?.includes('PAGE')) return 'page';
    if (routeName?.includes('BLOG')) return 'blogpost';
    if (routeName?.includes('SPACE')) return 'space';
    return 'page';
};
module.exports["getContentType"] = $5ff3d548ffdc5eda$export$1ef77878e4e0b972;

});

parcelRegister("8a9Dm", function(module, exports) {
const $2cc1b73219e08564$export$fb2283f4a44fb53 = (app)=>{
    if (!app?.id) return;
    const [, id] = app.id.split('/');
    return id;
};
const $2cc1b73219e08564$export$b17b21a48c0a3273 = (module)=>{
    if (!module.id) return;
    const parts = module.id.split('/');
    return parts[parts.length - 1];
};
const $2cc1b73219e08564$var$isMigratedFromConnect = (app)=>{
    if (!app.properties) return false;
    const props = app.properties;
    return props.migratedFromConnect === true || props.migratedFromConnect === 'true';
};
const $2cc1b73219e08564$export$9eb690901638fb96 = (app)=>{
    if ($2cc1b73219e08564$var$isMigratedFromConnect(app) && app.migrationKey) return `ac:${app.migrationKey}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
    return `forge:${$2cc1b73219e08564$export$fb2283f4a44fb53(app)}:${app.environmentId}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
};
module.exports["getAppId"] = $2cc1b73219e08564$export$fb2283f4a44fb53;
module.exports["getModuleKey"] = $2cc1b73219e08564$export$b17b21a48c0a3273;
module.exports["getCustomContentType"] = $2cc1b73219e08564$export$9eb690901638fb96;

});

parcelRegister("dizL5", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $55b20ed34f146485$export$350b371bfb7f5e95 = (loadingComponent)=>(0, $jmjWc.LoadableAfterPaint)({
        __loadable_id__: "UJdch",
        name: "lazyForgeUIExtensionsWithLoader",
        loader: async ()=>(await (parcelRequire("i2HVB"))).ForgeUIExtensionsWrapper,
        loading: loadingComponent
    });
const $55b20ed34f146485$export$4cbc6d03d50a8849 = $55b20ed34f146485$export$350b371bfb7f5e95(undefined);
module.exports["lazyForgeUIExtensionsWithLoader"] = $55b20ed34f146485$export$350b371bfb7f5e95;
module.exports["LazyForgeUIExtensions"] = $55b20ed34f146485$export$4cbc6d03d50a8849;

});

parcelRegister("i2HVB", function(module, exports) {

let $d22a7d17917e1bac$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d22a7d17917e1bac$var$load("1NGPq"),
    $d22a7d17917e1bac$var$load("lnKog")
]).then(()=>parcelRequire('2mcHd'));

});

parcelRegister("6UqI3", function(module, exports) {
const $a3c7cd489159fe33$export$28eddf802cd184f7 = (spaceKey)=>{
    return spaceKey?.[0] === '~' ? 'personal' : 'global';
};
module.exports["getSpaceType"] = $a3c7cd489159fe33$export$28eddf802cd184f7;

});

parcelRegister("c54hr", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $367766f6f044c46b$var$initialState = {
    isMenuOpen: false,
    isCloseMenuDisabled: false
};
const $367766f6f044c46b$var$actions = {
    setIsMenuOpen: (isMenuOpen)=>({ setState: setState })=>{
            setState({
                isMenuOpen: isMenuOpen
            });
        },
    setIsCloseMenuDisabled: (isCloseMenuDisabled)=>({ setState: setState })=>{
            setState({
                isCloseMenuDisabled: isCloseMenuDisabled
            });
        }
};
const $367766f6f044c46b$var$Store = (0, $8s9DV.createStore)({
    initialState: $367766f6f044c46b$var$initialState,
    actions: $367766f6f044c46b$var$actions,
    name: 'more-actions-menu-store'
});
const $367766f6f044c46b$export$14d00db016c2b3ef = (0, $kBr4q.createStateHook)($367766f6f044c46b$var$Store);
const $367766f6f044c46b$export$1f1f8c486fa8a1cb = (0, $kBr4q.createActionsHook)($367766f6f044c46b$var$Store);
module.exports["useMoreActionsMenuState"] = $367766f6f044c46b$export$14d00db016c2b3ef;
module.exports["useMoreActionsMenuActions"] = $367766f6f044c46b$export$1f1f8c486fa8a1cb;

});

parcelRegister("9fBoq", function(module, exports) {

var $hBxDy = parcelRequire("hBxDy");

const $6ca0453d93f30f16$var$capitalize = (str)=>{
    if (!str || !str.length) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
const $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e = (extension, overriddenTitle)=>{
    const title = overriddenTitle || extension.properties.title;
    const { environmentType: environmentType, environmentKey: environmentKey } = extension;
    if (environmentType === (0, $hBxDy.ProductEnvironment).PRODUCTION) return title;
    if (environmentType === (0, $hBxDy.ProductEnvironment).DEVELOPMENT && environmentKey !== 'default') return `${title} - ${environmentKey} (Dev)`;
    return `${title} (${$6ca0453d93f30f16$var$capitalize(environmentType)})`;
};
module.exports["extensionTitle"] = $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e;

});

parcelRegister("hBxDy", function(module, exports) {
var $77348f0599087222$export$2688cec3c24cb60b = /*#__PURE__*/ function(ProductEnvironment) {
    ProductEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ProductEnvironment["STAGING"] = "STAGING";
    ProductEnvironment["PRODUCTION"] = "PRODUCTION";
    return ProductEnvironment;
}({});
var $77348f0599087222$export$beaef1891b3e7ca3 = /*#__PURE__*/ function(ForgeCDNEnvironment) {
    ForgeCDNEnvironment["DEVELOPMENT"] = "dev";
    ForgeCDNEnvironment["STAGING"] = "stg";
    ForgeCDNEnvironment["PRODUCTION"] = "prod";
    return ForgeCDNEnvironment;
}({});
module.exports["ProductEnvironment"] = $77348f0599087222$export$2688cec3c24cb60b;
module.exports["ForgeCDNEnvironment"] = $77348f0599087222$export$beaef1891b3e7ca3;

});

parcelRegister("9MrOn", function(module, exports) {
/* ContentToolsButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $6b4nE = parcelRequire("6b4nE");


var $kSwu1 = parcelRequire("kSwu1");


var $6TaGl = parcelRequire("6TaGl");


var $1sCHt = parcelRequire("1sCHt");


var $3vgx3 = parcelRequire("3vgx3");

const $43c0d8bb08806c39$var$NOOP = ()=>{};
const $43c0d8bb08806c39$var$i18n = (0, $kSwu1.defineMessages)({
    triggerLabel: {
        id: "content-tools.more.icon.label",
        defaultMessage: "More actions"
    }
});
const $43c0d8bb08806c39$var$dropdownMenuCollaboratorStyle = null;
const $43c0d8bb08806c39$var$dropdownMenuNonCollaboratorStyle = null;
const $43c0d8bb08806c39$var$ContentToolsButtonComponent = ({ isDisabled: isDisabled, isOpen: isOpen = false, onOpenChange: onOpenChange = $43c0d8bb08806c39$var$NOOP, onPositioned: onPositioned = $43c0d8bb08806c39$var$NOOP, children: children, isExternalCollaborator: isExternalCollaborator = false })=>{
    'use no memo';
    const intl = (0, $kSwu1.useIntl)();
    const [drodownMenuMaxHeight, setDropdownMenuMaxHeight] = (0, $cozmU.useState)('auto');
    const dropdownMenuContainerRef = (0, $cozmU.useRef)(null);
    const handleOnOpenChange = (obj)=>{
        onOpenChange(obj);
        if (obj.isOpen) {
            const distanceFromTop = dropdownMenuContainerRef.current?.getBoundingClientRect().bottom ?? 0;
            const availableHeight = window.innerHeight - distanceFromTop - 16;
            setDropdownMenuMaxHeight(`${availableHeight}px`);
        }
    };
    return /*#__PURE__*/ $cozmU.createElement("div", {
        "data-id": "content-tools-dropdown-menu-container",
        "data-test-id": "content-tools-dropdown-menu-container",
        "data-testid": "content-tools-dropdown-menu-container",
        ref: dropdownMenuContainerRef,
        className: (0, $hekY6.default)([
            "_18u019bv _1ul91tcg",
            isExternalCollaborator && "_18u0idpf _1ul91tcg"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $3vgx3.default), {
        testId: "content-tools-dropdown-menu",
        appearance: "tall",
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
                ...props,
                "data-id": "page-more-action-button",
                "data-test-id": "page-more-action-button",
                id: "tools-menu-trigger",
                label: intl.formatMessage($43c0d8bb08806c39$var$i18n.triggerLabel),
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))),
                ref: triggerRef,
                appearance: "subtle",
                isDisabled: isDisabled
            }),
        placement: "bottom-end",
        isOpen: isOpen,
        onOpenChange: handleOnOpenChange,
        shouldFlip: false,
        onPositioned: onPositioned,
        shouldRenderToParent: true
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        style: {
            maxHeight: drodownMenuMaxHeight
        }
    }, children || null)));
};
$43c0d8bb08806c39$var$ContentToolsButtonComponent.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).node,
    isDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool,
    isExternalCollaborator: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool,
    isOpen: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool,
    onOpenChange: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).func,
    onPositioned: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).func
};
const $43c0d8bb08806c39$export$f221d384e5b0f4c3 = /*#__PURE__*/ (0, $cozmU.memo)($43c0d8bb08806c39$var$ContentToolsButtonComponent);
module.exports["ContentToolsButton"] = $43c0d8bb08806c39$export$f221d384e5b0f4c3;

});

parcelRegister("ir4h8", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $ac2J9 = parcelRequire("ac2J9");

/**
 * __useRouterLink()__
 *
 * Hook: Returns app-configured router link component.
 *
 * A generic can be passed to define advanced link configuration:
 * ```
 * type MyRouterLinkConfig = {
 *  to: string;
 *  replace?: boolean;
 * }
 *
 * const RouterLink = useRouterLink<MyRouterLinkConfig>();
 * ```
 */ const $abc73c6f5c74c436$var$useRouterLink = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $cozmU.useContext)((0, $ac2J9.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
} : ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $cozmU.useContext)((0, $ac2J9.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
    return;
};
var $abc73c6f5c74c436$export$2e2bcd8739ae039 = $abc73c6f5c74c436$var$useRouterLink;
module.exports["default"] = $abc73c6f5c74c436$export$2e2bcd8739ae039;

});

parcelRegister("ac2J9", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $b797161b98bd0492$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $cozmU.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ const $b797161b98bd0492$var$RouterLinkProvider = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { routerLinkComponent: routerLinkComponent, children: children } = t0;
    let t1;
    if ($[0] !== routerLinkComponent) {
        t1 = {
            routerLinkComponent: routerLinkComponent
        };
        $[0] = routerLinkComponent;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== children || $[3] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b797161b98bd0492$export$2931e0ee690eee88.Provider, {
            value: t1
        }, children);
        $[2] = children;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ routerLinkComponent: routerLinkComponent, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b797161b98bd0492$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        }
    }, children);
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$b797161b98bd0492$export$2e2bcd8739ae039 = $b797161b98bd0492$var$RouterLinkProvider;
module.exports["RouterLinkProviderContext"] = $b797161b98bd0492$export$2931e0ee690eee88;

});

parcelRegister("dmDX7", function(module, exports) {

var $7NYI2 = parcelRequire("7NYI2");


var $cozmU = parcelRequire("cozmU");


var $jMyy4 = parcelRequire("jMyy4");


var $bQm3c = parcelRequire("bQm3c");


var $6mKj3 = parcelRequire("6mKj3");

const $4aa29e57813b75ee$var$UsePendingRequestExistsQuery = (0, $7NYI2.default);
const $4aa29e57813b75ee$export$5354a7f39c2c364a = ({ contentId: contentId })=>{
    const { userId: userId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const shouldSkip = !userId || !cloudId || !contentId || !(0, $6mKj3.expValEquals)('confluence_frontend_existing_access_request_checks', 'cohort', 'experiment');
    const [isLoadingForFirstTime, setIsLoadingForFirstTime] = (0, $cozmU.useState)(!shouldSkip);
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)($4aa29e57813b75ee$var$UsePendingRequestExistsQuery, {
        variables: {
            cloudId: cloudId,
            accessRequestedAaid: userId ?? '',
            contentId: contentId ?? ''
        },
        skip: shouldSkip,
        fetchPolicy: 'network-only',
        onCompleted: ()=>{
            setIsLoadingForFirstTime(false);
        },
        __callerPackage__: "@confluence/access-requests"
    });
    const pendingRequestExists = Boolean(data?.confluence_pendingRequestExists?.isPendingAccessRequestExists);
    return {
        pendingRequestExists: pendingRequestExists,
        loading: loading,
        error: error,
        isLoadingForFirstTime: isLoadingForFirstTime
    };
};
module.exports["usePendingRequestExists"] = $4aa29e57813b75ee$export$5354a7f39c2c364a;

});

parcelRegister("7NYI2", function(module, exports) {
/**
 * @generated SignedSource<<4d7ccfc95dff4e3b611db90e9453df55>>
 * @relayHash f8787096f4d42896880d52d9cbd4670c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ca265d253ef91a90727e0b2a379d714b1851230382cb448d534c1124fd0266b9
const $3cde78eca68e7b16$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accessRequestedAaid"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "accessRequestedAaid",
                    "variableName": "accessRequestedAaid"
                },
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "ConfluencePendingAccessRequest",
            "kind": "LinkedField",
            "name": "confluence_pendingRequestExists",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isPendingAccessRequestExists"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "usePendingRequestExistsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "usePendingRequestExistsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "f8787096f4d42896880d52d9cbd4670c",
            "id": "ca265d253ef91a90727e0b2a379d714b1851230382cb448d534c1124fd0266b9",
            "metadata": {},
            "name": "usePendingRequestExistsQuery",
            "operationKind": "query",
            "text": "query usePendingRequestExistsQuery($accessRequestedAaid:String!,$cloudId:ID!,$contentId:ID!){confluence_pendingRequestExists(accessRequestedAaid:$accessRequestedAaid,cloudId:$cloudId,contentId:$contentId){isPendingAccessRequestExists}}"
        }
    };
}();
$3cde78eca68e7b16$var$node.hash = "4d877c3ca505e954e3d6f173f1138ce0";
var $3cde78eca68e7b16$export$2e2bcd8739ae039 = $3cde78eca68e7b16$var$node;
module.exports["default"] = $3cde78eca68e7b16$export$2e2bcd8739ae039;

});


//# sourceMappingURL=ForgeContentTools.30824ffa.js.map
